import { loadQs } from './globalLoader';

/**
 * 根据二维码返回柜子编号，非合法柜子是throw Error
 * @param {String} url 二维码地址
 */
export async function getQrcodeByUrl(url) {
  if (!/^(http|https):\/\/c3x\.me.*\?p=.+$/.test(url)) {
    throw new Error('亲，我不认识这个二维码哦');
  }
  const qs = await loadQs();
  const query = qs.parse(url.split('?').pop());
  if (!query.p) {
    throw new Error('亲，这个二维码好像坏掉了');
  }
  return query.p;
}

/**
 * 绑定车辆识别二维码
 * @param {String} url 二维码地址
 */
export async function getBikeQrcodeByUrl(url) {
  if (/^(http|https):\/\/c3x\.me.*\?p=.+$/.test(url)) {
    throw new Error('亲，这是个柜体二维码哦，请扫描电池底座二维码');
  }
  if (!/^(http|https):\/\/c3x\.me.*\?(z|ic|ba)=.+$/.test(url)) {
    throw new Error('请扫描电池底座二维码');
  }
  const qs = await loadQs();
  const query = qs.parse(url.split('?').pop());
  const val = query.z || query.ba || query.ic;
  if (val) {
    return val;
  }
  throw new Error('请扫描电池底座二维码');
}

// /**
//  * 绑定电池识别二维码
//  * @param {String} url 二维码地址
//  */
export function getBatteryQrcodeByUrl(url) {
  if (/^(http|https):\/\/c3x\.me.*\?p=.+$/.test(url)) {
    throw new Error('亲，这是个柜体二维码哦，请扫描电池底座二维码');
  }
  const reg = /^((http|https):\/\/c3x\.me.*\?b=)?([\da-zA-Z]{10})$/;
  if (!reg.test(url)) {
    throw new Error('请扫描电池二维码');
  }
  return url.replace(reg, (s, s1, s2, s3) => s3);
}

// 电池url码转换
export function transferUrlBatteryNo(url) {
  const num = url.indexOf('?b=');
  let batteryNo;
  if (num !== -1) {
    batteryNo = url.substring(num + 3);
    if (!/^[\da-zA-Z]{10}$/.test(batteryNo)) {
      throw new Error('请扫描电池二维码');
    }
    return batteryNo;
  }
  throw new Error('请扫描电池二维码');
}

// 电池电量重定向
export function getPower(i) {
  if (i >= 95) return 100;
  if (i >= 90) return Math.round(i * 1.05, 0);
  if (i >= 80) return Math.round(i * 1.03, 0);
  return i;
}
